<template>
  <div class="z-10 hide-not-first">
    <InvalidPaymentMethodBanner />
    <IntegrationsIssueBanner />
  </div>
</template>
<script>

import InvalidPaymentMethodBanner from '@/views/messages/InvalidPaymentMethodBanner.vue';
import IntegrationsIssueBanner from '@/views/messages/IntegrationsIssueBanner.vue';

export default {
  name: 'AppLevelBannerContainer',
  components: {
    InvalidPaymentMethodBanner,
    IntegrationsIssueBanner,
  },
};
</script>
